// extracted by mini-css-extract-plugin
module.exports = {"orderhistory":"OrderHistoryScreen_orderhistory__1-4Is","table":"OrderHistoryScreen_table__kWjXM"};